import template from './contract_type_component.html';
import tr from '../../lib/default-translator.js';

class AdminContractTypeComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.contract_types = ko.observableArray();

		// PAGE LOAD
		this.init();
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'contract_type',
			schema: 'public'
		});

		if (res.status == 'OK')
		{
			if (res.records)
				this.contract_types(res.records);
		}
		else
			Grape.alerts.apiError(res);
	};

	edit_contract_type(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();

		view_row.hide();
		edit_row.show();
	};

	async delete_contract_type(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();

		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'danger', title: tr('Delete contract type?'), message: tr('Are you sure you want to delete this contract type entry ?')});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/contract_type/delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully deleted contract type.'), title: tr('Success')});
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		} 
	};

	async save_contract_type(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();

		let data = ko.mapping.toJS(v);
		
		let response = false;

		if (!data.contract_type_id) 
			response = true; 

		if (!response) { 
			let res_in_use = await Grape.fetches.getJSON('/admin/contract_type/active', data); 
			if (res_in_use.status == 'OK') 
			{
				if (res_in_use.active) {
					response = await Grape.alerts.confirm({type: 'warning', title: tr('Edit contract type?'), message: tr('This contract type is currently in use by at least one employee. Are you sure you want to edit this contract type entry? This would update the contract type for all the employees that are currently using it.')});
				}
				else 
					response = true; 
			}
			else if (res_in_use.status == 'ERROR')
			{
				Grape.alerts.apiError(res_in_use);
				this.updateData();
				return; 
			}
			else if (res_in_use.error)
			{
				Grape.alerts.alert({type: 'error', message: res_in_use.error, title: tr('Error')});
				this.updateData();
				return; 
			}
			else { 
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
				return;
			}
		}

		
		if (!response) {
			return; 
			edit_row.hide();
			this.updateData();
		}
		let res = await Grape.fetches.postJSON('/admin/contract_type/edit', data)
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully saved contract type.'), title: tr('Success')});
			edit_row.hide();
			this.updateData();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.updateData();
		}
		else if (res.error)
		{
			Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error')});
			this.updateData();
		}
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
	};

	add_contract_type(data)
	{
		let contract_types = data.contract_types;
		contract_types.unshift({ 'name': '', 'name': '' });
		let row = $('#contract_type_body > tr:first-child');

		row.hide();
		row.next().show();
	}

	cancel_save(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		edit_row.hide();
		this.updateData();
	}

	init()
	{
		this.updateData();
	}
}

export default {
	name: 'contract_type_component',
	viewModel: AdminContractTypeComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/contract_type_component'
};
